import { initializeApp } from "./script";

document.addEventListener("DOMContentLoaded", () => {
  initializeApp();
});
